export default __webpack_public_path__ + "static/carousel-hero-web-2x-30fd737b8acbca584067f4a0b734a4fa.png";